import React, { useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MateManagement from './MateManagement/MateManagement';
import ChampionsLeagueAdmin from './CLAdmin/ChampionsLeagueAdmin';
import ChampionsLeaguePhaseControlsAdmin from './CLAdmin/ChampionsLeaguePhaseControlsAdmin';
import ChampionsLeagueTeamsAdmin from './CLAdmin/ChampionsLeagueTeamsAdmin';
import LandskampAdmin from './LandskampAdmin/LandskampAdmin';
import KampdagAdmin from './KampdagAdmin/KampdagAdmin';
import WorldCupAdmin from './WorldCupAdmin/WorldCupAdmin';
import HoldAdmin from './HoldAdmin/HoldAdmin';
import Picture from '../../images/Svirr.png';
import championsLeagueIcon from '../../images/uefaChampionsLeague.jpg';
import worldCupIcon from '../../images/World-CUp-2026.jpg';
import landskampIcon from '../../images/landskamp.jpg';
import kampdagIcon from '../../images/kampdagIcon.svg';

import BackHeader from '../../components/BackHeader/BackHeader';
import './AdminPanel.css';
import '../HomePage/HomePage.css';

const ADMIN_PAGE_META = {
  0: { area: 'Mate Management', page: 'Brugere', icon: '👥', theme: 'mate' },
  5: { area: 'Mate Management', page: 'Signup Links', icon: '👥', theme: 'mate' },
  8: { area: 'Mate Management', page: 'Send notifikationer', icon: '👥', theme: 'mate' },
  1: { area: 'Champions League', page: 'Administrer spil', icon: '🏆', theme: 'cl' },
  2: { area: 'Champions League', page: 'CL Hold', icon: '🏆', theme: 'cl' },
  6: { area: 'Champions League', page: 'Phase Controls', icon: '🏆', theme: 'cl' },
  4: { area: 'Landskamp', page: null, icon: '🇩🇰', theme: 'landskamp' },
  7: { area: 'Kampdag', page: null, icon: '📅', theme: 'kampdag' },
  9: { area: 'World Cup 2026', page: 'VM-faser', icon: '🌍', theme: 'worldcup' },
  10: { area: 'World Cup 2026', page: 'VM-hold', icon: '🌍', theme: 'worldcup' },
  11: { area: 'World Cup 2026', page: 'Opret/rediger kampe', icon: '🌍', theme: 'worldcup' },
  12: { area: 'World Cup 2026', page: 'Sæt verdensmester', icon: '🌍', theme: 'worldcup' },
  13: { area: 'World Cup 2026', page: 'Leaderboard', icon: '🌍', theme: 'worldcup' },
  14: { area: 'Hold', page: 'Alle hold', icon: '⚽', theme: 'default' },
};

function AdminPageHeader({ activeTab, onBack, backLabel }) {
  const meta = ADMIN_PAGE_META[activeTab] || {
    area: 'Admin',
    page: null,
    icon: '⚙️',
    theme: 'default',
  };

  return (
    <BackHeader
      theme={meta.theme}
      eyebrow="Admin panel"
      title={meta.area}
      subtitle={meta.page}
      onBack={onBack}
      backLabel={backLabel}
    />
  );
}

function Glyph({ name }) {
  const stroke = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };

  if (name === 'mates') {
    return (
      <svg {...stroke} aria-hidden="true">
        <circle cx="9" cy="8" r="2.6" />
        <circle cx="16.5" cy="9" r="2.1" />
        <path d="M3.8 19.2c.5-2.8 2.6-4.2 5.2-4.2s4.7 1.4 5.2 4.2" />
        <path d="M14.2 15.2c1.5-.3 2.9.2 3.8 1.5.6.9.8 1.8.7 2.5" />
      </svg>
    );
  }

  if (name === 'link') {
    return (
      <svg {...stroke} aria-hidden="true">
        <path d="M10 13a4.5 4.5 0 0 0 6.4.1l1.6-1.6a4.5 4.5 0 0 0-6.4-6.4L10.4 6.3" />
        <path d="M14 11a4.5 4.5 0 0 0-6.4-.1l-1.6 1.6a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2" />
      </svg>
    );
  }

  if (name === 'bell') {
    return (
      <svg {...stroke} aria-hidden="true">
        <path d="M6 16.5h12l-1.2-1.6V10a4.8 4.8 0 0 0-9.6 0v4.9L6 16.5z" />
        <path d="M10 16.5a2 2 0 0 0 4 0" />
      </svg>
    );
  }

  if (name === 'lock') {
    return (
      <svg {...stroke} aria-hidden="true">
        <rect x="5" y="10.5" width="14" height="9" rx="2" />
        <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
      </svg>
    );
  }

  if (name === 'team') {
    return (
      <svg {...stroke} aria-hidden="true">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8.2v7.6M8.2 12h7.6" />
      </svg>
    );
  }

  if (name === 'ball') {
    return (
      <svg {...stroke} aria-hidden="true">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 4.2 14.4 9.2 12 12 9.6 9.2z" />
        <path d="M9.6 9.2 5.2 10.2 7.2 14.6 12 12" />
        <path d="M14.4 9.2 18.8 10.2 16.8 14.6 12 12" />
        <path d="M7.2 14.6 9 19.2h6l1.8-4.6" />
      </svg>
    );
  }

  if (name === 'list') {
    return (
      <svg {...stroke} aria-hidden="true">
        <path d="M8 7h11M8 12h11M8 17h11" />
        <circle cx="4.5" cy="7" r="0.8" fill="currentColor" stroke="none" />
        <circle cx="4.5" cy="12" r="0.8" fill="currentColor" stroke="none" />
        <circle cx="4.5" cy="17" r="0.8" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  if (name === 'matches') {
    return (
      <svg {...stroke} aria-hidden="true">
        <rect x="4" y="5" width="16" height="15" rx="2" />
        <path d="M8 3.5V7M16 3.5V7M4 10h16" />
      </svg>
    );
  }

  if (name === 'crown') {
    return (
      <svg {...stroke} aria-hidden="true">
        <path d="M4 16.5 6.2 8l3.3 4.2L12 6.5l2.5 5.7L17.8 8 20 16.5z" />
        <path d="M5 19h14" />
      </svg>
    );
  }

  if (name === 'board') {
    return (
      <svg {...stroke} fill="currentColor" stroke="none" aria-hidden="true">
        <rect x="3" y="13" width="4.5" height="7" rx="1.2" />
        <rect x="9.75" y="8" width="4.5" height="12" rx="1.2" />
        <rect x="16.5" y="4" width="4.5" height="16" rx="1.2" />
      </svg>
    );
  }

  return (
    <svg {...stroke} aria-hidden="true">
      <path d="M8 8 4.5 12 8 16" />
      <path d="M16 8 19.5 12 16 16" />
      <path d="M13 6.5 11 17.5" />
    </svg>
  );
}

function AdminAppButton({ app, onClick }) {
  return (
    <button type="button" className="home-app" onClick={onClick}>
      <span className="home-app-icon" style={{ background: app.background || '#111111' }}>
        {app.image ? (
          <img
            className={[
              'home-app-image',
              app.fit === 'contain' ? 'home-app-image--contain' : '',
            ].filter(Boolean).join(' ')}
            src={app.image}
            alt=""
            style={{ objectPosition: app.position || 'center' }}
          />
        ) : (
          <span className="admin-app-glyph">
            <Glyph name={app.glyph} />
          </span>
        )}
      </span>
      <span className="home-app-label">{app.label}</span>
    </button>
  );
}

const LAUNCHER_APPS = [
  { key: 'mate', label: 'Mate', glyph: 'mates', folder: 'mate' },
  { key: 'hold', label: 'Hold', glyph: 'team', tab: 14 },
  {
    key: 'cl',
    label: 'CL spil',
    image: championsLeagueIcon,
    fit: 'cover',
    position: '12% center',
    folder: 'cl',
  },
  {
    key: 'landskamp',
    label: 'Landskamp',
    image: landskampIcon,
    fit: 'cover',
    position: 'center 46%',
    tab: 4,
  },
  { key: 'kampdag', label: 'Kampdag', image: kampdagIcon, fit: 'cover', tab: 7 },
  {
    key: 'worldcup',
    label: 'World Cup',
    image: worldCupIcon,
    fit: 'cover',
    position: 'center 42%',
    folder: 'worldcup',
  },
];

const ADMIN_FOLDERS = {
  mate: {
    title: 'Mate',
    apps: [
      { key: 'users', label: 'Brugere', glyph: 'mates', tab: 0, parent: 'mate' },
      { key: 'links', label: 'Signup Links', glyph: 'link', tab: 5, parent: 'mate' },
      { key: 'push', label: 'Notifikationer', glyph: 'bell', tab: 8, parent: 'mate' },
    ],
  },
  cl: {
    title: 'CL spil',
    apps: [
      {
        key: 'games',
        label: 'Administrer',
        image: championsLeagueIcon,
        fit: 'cover',
        position: '12% center',
        tab: 1,
        parent: 'cl',
      },
      { key: 'phase', label: 'Phase Controls', glyph: 'lock', tab: 6, parent: 'cl' },
      { key: 'teams', label: 'CL Hold', glyph: 'ball', tab: 2, parent: 'cl' },
    ],
  },
  worldcup: {
    title: 'World Cup',
    apps: [
      { key: 'stages', label: 'VM-faser', glyph: 'list', tab: 9, parent: 'worldcup' },
      { key: 'teams', label: 'VM-hold', glyph: 'ball', tab: 10, parent: 'worldcup' },
      { key: 'matches', label: 'Kampe', glyph: 'matches', tab: 11, parent: 'worldcup' },
      { key: 'champion', label: 'Mester', glyph: 'crown', tab: 12, parent: 'worldcup' },
      { key: 'board', label: 'Leaderboard', glyph: 'board', tab: 13, parent: 'worldcup' },
    ],
  },
};

const AdminPanel = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [screen, setScreen] = useState('launcher');
  const [folder, setFolder] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  const openApp = useCallback((app) => {
    if (app.folder) {
      setFolder(app.folder);
      setScreen('folder');
      return;
    }

    setActiveTab(app.tab);
    setFolder(app.parent || null);
    setScreen('tool');
  }, []);

  useEffect(() => {
    if (location.pathname !== '/admin') return;
    setScreen('launcher');
    setFolder(null);
    setActiveTab(null);
  }, [location.pathname, location.key, location.state?.resetDashboard]);

  const renderActiveSection = () => {
    switch (activeTab) {
      case 0:
        return <MateManagement initialTab="users" />;
      case 5:
        return <MateManagement initialTab="signup-links" />;
      case 8:
        return <MateManagement initialTab="send-notifications" />;
      case 1:
        return <ChampionsLeagueAdmin />;
      case 2:
        return <ChampionsLeagueTeamsAdmin />;
      case 6:
        return <ChampionsLeaguePhaseControlsAdmin />;
      case 4:
        return <LandskampAdmin />;
      case 7:
        return <KampdagAdmin />;
      case 9:
        return <WorldCupAdmin section="stages" />;
      case 10:
        return <WorldCupAdmin section="teams" />;
      case 11:
        return <WorldCupAdmin section="matches" />;
      case 12:
        return <WorldCupAdmin section="champion" />;
      case 13:
        return <WorldCupAdmin section="leaderboard" />;
      case 14:
        return <HoldAdmin />;
      default:
        return null;
    }
  };

  const goBack = () => {
    if (screen === 'tool' && folder) {
      setScreen('folder');
      setActiveTab(null);
      return;
    }

    setScreen('launcher');
    setFolder(null);
    setActiveTab(null);
  };

  if (screen !== 'tool') {
    const apps = screen === 'folder' ? ADMIN_FOLDERS[folder].apps : LAUNCHER_APPS;
    const title = screen === 'folder' ? ADMIN_FOLDERS[folder].title : 'Admin';

    return (
      <main className="home-screen">
        <img className="home-screen-logo" src={Picture} alt="Svirr" />
        <BackHeader
          eyebrow={screen === 'folder' ? 'Admin' : 'Svirr'}
          title={title}
          onBack={screen === 'folder' ? goBack : () => navigate('/')}
          backLabel={screen === 'folder' ? 'Tilbage til Admin' : 'Tilbage'}
        />
        <nav className="home-app-grid" aria-label={title}>
          {apps.map((app) => (
            <AdminAppButton key={app.key} app={app} onClick={() => openApp(app)} />
          ))}
        </nav>
      </main>
    );
  }

  const backLabel = folder ? ADMIN_FOLDERS[folder].title : 'Admin';

  return (
    <div className="admin-panel admin-theme">
      <div className="admin-tool">
        <main className="admin-content-area">
          <AdminPageHeader
            activeTab={activeTab}
            onBack={goBack}
            backLabel={`Tilbage til ${backLabel}`}
          />
          {renderActiveSection()}
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;
